export const validateToken = () => {
    const token = localStorage.getItem("token");

    if (!token || token.length === 0) {
        return {
            isValid: false,
            message: 'No token found'
        };
    }

    try {
        // Basic JWT structure validation
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
            localStorage.removeItem("token");
            return {
                isValid: false,
                message: 'Invalid token format'
            };
        }

        // Check token expiration
        const payload = JSON.parse(atob(tokenParts[1]));
        const currentTime = Math.floor(Date.now() / 1000);

        if (payload.exp && payload.exp < currentTime) {
            localStorage.removeItem("token");
            return {
                isValid: false,
                message: 'Token expired'
            };
        }

        return {
            isValid: true,
            payload
        };
    } catch (error) {
        console.error('Token validation failed:', error);
        return {
            isValid: false,
            message: 'Token validation failed',
            error
        };
    }
};



// WEBPACK FOOTER //
// ./src/utils/tokenUtils.js